import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"bg-white\"><div class=\"container flex flex-col items-center justify-center py-5 mx-auto max-w-7xl md:flex-row bg-white\"><a href=\"#_\" class=\"flex items-center inline-block font-arial text-2xl font-bold text-center text-black no-underline bg-transparent cursor-pointer focus:no-underline\"><span>Add Service</span></a></div></section><section style=\"background-color:#457B9D;\"><div class=\"container flex items-center justify-center pt-2 pb-2 mx-auto text-gray-600\"><input class=\"rounded-lg border-2 items-center border-black-100 bg-white h-10 px-5 pr-16 text-sm focus:outline-none\" type=\"search\" name=\"search\" placeholder=\"Search\"></div></section>", 2)
const _hoisted_3 = { class: "bg-white" }
const _hoisted_4 = { class: "max-w-1xl px-10 mx-auto sm:text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  for: "my-modal-2",
  id: "request Service",
  class: "modal-button mb-8 w-full lg:w-1/3 py-3 mt-5 bg-gray-800 rounded-lg font-arial font-bold text-white focus:outline-none bg-red-700 hover:shadow-none"
}, " Request unlisted service ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "my-modal-2",
  class: "modal-toggle"
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-auto",
  viewBox: "0 0 256 256",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M159.999 128.056a76.55 76.55 0 0 1-4.915 27.024 76.745 76.745 0 0 1-27.032 4.923h-.108c-9.508-.012-18.618-1.75-27.024-4.919A76.557 76.557 0 0 1 96 128.056v-.112a76.598 76.598 0 0 1 4.91-27.02A76.492 76.492 0 0 1 127.945 96h.108a76.475 76.475 0 0 1 27.032 4.923 76.51 76.51 0 0 1 4.915 27.02v.112zm94.223-21.389h-74.716l52.829-52.833a128.518 128.518 0 0 0-13.828-16.349v-.004a129 129 0 0 0-16.345-13.816l-52.833 52.833V1.782A128.606 128.606 0 0 0 128.064 0h-.132c-7.248.004-14.347.62-21.265 1.782v74.716L53.834 23.665A127.82 127.82 0 0 0 37.497 37.49l-.028.02A128.803 128.803 0 0 0 23.66 53.834l52.837 52.833H1.782S0 120.7 0 127.956v.088c0 7.256.615 14.367 1.782 21.289h74.716l-52.837 52.833a128.91 128.91 0 0 0 30.173 30.173l52.833-52.837v74.72a129.3 129.3 0 0 0 21.24 1.778h.181a129.15 129.15 0 0 0 21.24-1.778v-74.72l52.838 52.837a128.994 128.994 0 0 0 16.341-13.82l.012-.012a129.245 129.245 0 0 0 13.816-16.341l-52.837-52.833h74.724c1.163-6.91 1.77-14 1.778-21.24v-.186c-.008-7.24-.615-14.33-1.778-21.24z",
    fill: "#FF4A00"
  })
], -1)
const _hoisted_10 = { class: "font-bold mt-4" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\"><div class=\"modal-box\"><p>Enim dolorem dolorum omnis atque necessitatibus. Consequatur aut adipisci qui iusto illo eaque. Consequatur repudiandae et. Nulla ea quasi eligendi. Saepe velit autem minima.</p><div class=\"modal-action\"><label for=\"my-modal-2\" class=\"btn btn-primary\">Accept</label><label for=\"my-modal-2\" class=\"btn\">Close</label></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        (_ctx.services && _ctx.services.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: service.id,
                    class: "py-10 flex flex-col items-center justify-center shadow-lg border border-gray-100"
                  }, [
                    _hoisted_9,
                    _createElementVNode("p", _hoisted_10, _toDisplayString(service.title), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_11
  ], 64))
}